// extracted by mini-css-extract-plugin
module.exports = {"container":"container-2OiPd","noEvent":"noEvent-13Ghh","header":"header-3RqT5","price":"price-O-L_D","orderFeeDisclaimer":"orderFeeDisclaimer-22IxB","content":"content-2vmT1"};